'use strict';

export default class AppActions {
    constructor() {
        this.generateActions(
            'logout',
            'loginUserSuccess',
            'logoutUserSuccess',
            'updatePasswordSuccess',
            'acceptTermsSuccess',
            'resetPasswordSuccess',
            'registerUserSuccess',
            'confirmEmailSuccess',
            'loadAccountDataSuccess',
            'updateAccountDataSuccess',
            'loadTermsSuccess',
            'toggleOffcanvas',
            'onError',
            'clearError',
            'noop'
        );
    }
}



// WEBPACK FOOTER //
// ./app/actions/appActions.js